"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var BadgingSearchType;
(function (BadgingSearchType) {
    BadgingSearchType[BadgingSearchType["Attendees"] = 0] = "Attendees";
    BadgingSearchType[BadgingSearchType["Guests"] = 1] = "Guests";
})(BadgingSearchType || (BadgingSearchType = {}));
exports.default = BadgingSearchType;
